import { Link, NavLink } from "react-router-dom";
import {
  StyledConteiner,
  StyledFlexConteiner,
} from "./StyledComponents/Containers";
import "./Waves.css";
import styled from "styled-components";
import { Logo, StyledLogo } from "./Logo";
import * as React from "react";
import { observer } from "mobx-react";
import { useStores } from "..";
import { ProfileDropdown } from "../ProfileWindow/AuthComponents/ProfileDropdown";
import { MailDefaultButton } from "./IconButtons";

const StyledTopWave = styled.div.attrs(() => ({
  className: "wave",
}))`
  ${{ backgroundImage: `url(/img/volna.svg)` }};
  justify-content: space-between;
  ${StyledLogo} {
    margin-left: 30px;
    width: auto;
    img {
      height: 70px;
    }
  }
`;

const NavBar: React.FC<{}> = observer(() => {
  let appStore = useStores();

  return (
    <>
      <NavLinkDefault className="nav-link" to="/" text="Главная" />
      <NavLinkDefault className="nav-link" to="/news/list" text="Новости" />
      <a className="nav-link" href="lessons.html">
        Занятия
      </a>
      <a className="nav-link" href="competition.html">
        Конкурс
      </a>
      <a className="nav-link" href="index-en.html">
        EN
      </a>
      <a className="nav-link" href="contacts.html">
        <MailDefaultButton />
      </a>

      {appStore.authStore.isAuth && <ProfileDropdown />}
    </>
  );
});

export const TopWaveDefault: React.FC<{}> = () => {
  return (
    <StyledTopWave>
      <NavLink className="logo" to="/">
        <Logo></Logo>
      </NavLink>

      <div className="nav-bar">
        <NavBar />
      </div>
    </StyledTopWave>
  );
};

const StyledTopWaveForMainWindow = styled(StyledTopWave)`
  left: -80px;
  padding-left: 80px;
  justify-content: space-evenly;
  position: relative;
  z-index: 1;

  & > .profile-dropdown {
    menu {
      right: auto;
    }
  }
`;

const NavLinkDefault: React.FC<{
  to: string;
  text: string;
  className?: string;
}> = ({ to, text, className = "" }) => {
  return (
    <NavLink
      className={className}
      to={to}
      style={({ isActive, isPending }) => {
        return {
          display: isActive ? "none" : "block",
        };
      }}
    >
      {text}
    </NavLink>
  );
};

export const TopWaveForMainWindow: React.FC<{}> = ({}) => {
  return (
    <StyledTopWaveForMainWindow>
      <NavBar />
    </StyledTopWaveForMainWindow>
  );
};

const StyledBottomWave = styled.div.attrs(() => ({
  className: "footer",
}))`
  ${StyledConteiner} {
    padding: 25.5px;
    height: 50px;
    ${{ backgroundImage: `url(/img/volna_blue_1.svg)` }};
  }
`;

export const BottomWave: React.FC<{}> = () => {
  return (
    <StyledBottomWave>
      <div className="pattern">
        <img src="/img/pattern.svg" />
      </div>
      <StyledFlexConteiner>
        <div className="copyright">
          &#169; Дедова Лариса, 2018 - 2026 &nbsp;
          <a href="contacts.html">
            <img
              width="24px"
              style={{ verticalAlign: "text-bottom" }}
              src="/img/mail_white.svg"
            />
          </a>
        </div>
        <div>
          Любое использование либо копирование материалов или подборки
          материалов сайта, иллюстраций, элементов дизайна и оформления
          допускается лишь с разрешения правообладателя и только со ссылкой на
          источник: <Link to="/">kotobot.app</Link>
        </div>
      </StyledFlexConteiner>
    </StyledBottomWave>
  );
};
